module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby Starter - Stellar by HTML5 UP"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/generic.json
// module id = 407
// module chunks = 52547762336625